import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import LangSelect from '../LangSelect';
import Breadcrumbs from '../Breadcrumbs';
import { withTranslation } from '../../src/i18n';
import Logo from '../Logo';
import route from '../../constants/routes';
import { colors } from '../../constants/styleConstants';
import ProfilesMenuDropdown from '../ProfilesMenuDropdown';

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    width: '100%',
    height: 80,
    backgroundColor: colors.white,
    display: 'flex',
    alignItems: 'center',
  },
  navbar: {
    width: '100%',
    backgroundColor: colors.white,
  },
  navBarBox: {
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 11px 0 rgba(0, 0, 0, 0.15)',
    height: 85,
    padding: '0 20px',
    listStyleType: 'none',
    margin: 0,
    '& > li:nth-child(1)': {
      order: 3,
    },
    '& > li:nth-child(2)': {
      flexGrow: 1,
      order: 2,
      display: 'none',
    },
    '& > li:nth-child(3)': {
      order: 1,
    },
    [theme.breakpoints.up(1025)]: {
      '& > li:nth-child(1)': {
        order: 1,
        flexGrow: 1,
        maxWidth: 240,
      },
      '& > li:nth-child(2)': {
        flexGrow: 3,
        order: 2,
        display: 'flex',
      },
      '& > li:nth-child(3)': {
        order: 3,
      },
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  headerButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down(1025)]: {
      display: 'none',
    },
  },
  artistSearchBar: {
    marginRight: '60px',
  },
  loginButton: {
    fontWeight: 'bold',
  },
  loginLink: {
    display: 'block',
    fontWeight: 'bold',
    backgroundColor: colors.primary,
    color: colors.white,
    letterSpacing: '0.02857em',
    padding: '12px 64px',
    '&:hover': {
      color: colors.white,
      backgroundColor: 'rgb(246, 152, 105)',
    },
  },
}));

const Header = ({ title, page, handleDrawerToggle, t, customBreadcrumbs, isLoggedIn }) => {
  const classes = useStyles();
  const router = useRouter();

  return (
    <div className={classes.headerWrapper}>
      <nav className={classes.navbar}>
        <ul className={classes.navBarBox}>
          <li>
            <Logo />
          </li>
          <li>
            <Breadcrumbs title={title} page={page} customBreadcrumbs={customBreadcrumbs} />
          </li>
          <li>
            <div className={classes.headerButtons}>
              <LangSelect />
              {isLoggedIn ? (
                <ProfilesMenuDropdown />
              ) : (
                <a className={classes.loginLink} href={`${route.LOGIN}?page=${encodeURIComponent(router.asPath)}`}>
                  {t('operabase.general.m_LOGIN')}
                </a>
              )}
            </div>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          </li>
        </ul>
      </nav>
    </div>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  page: PropTypes.string,
  handleDrawerToggle: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  customBreadcrumbs: PropTypes.array,
};

export default withTranslation()(Header);
